import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';

/**
 * District ↔ child partner relationship icon.
 *
 * Wrapped in MUI's SvgIcon (rather than imported as an asset URL) so the
 * fill inherits `currentColor` from the surrounding theme and the icon
 * scales via the standard `fontSize` prop. The `<img src=district_child_relation.svg>`
 * approach used elsewhere bakes in the original black fill and can't be
 * recoloured by CSS — that produced the faint, hard-to-spot badge in
 * message list rows and detail banners.
 *
 * Stroke width is widened slightly so the line-art reads as bold at the
 * small sizes used inline next to a message name.
 */
const DistrictChildRelationIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon viewBox='0 0 202.205 202.205' {...props}>
    <path d='M172.912,38.304V0h-38.315v12.551H96.114V96.79H80.993V73.692h-51.7v51.707h51.7v-23.098h15.121v84.246h38.483v15.657h38.315V163.89h-38.315v17.146h-32.976v-78.735h32.976V118.7h38.315V80.392h-38.315V96.79h-32.976V18.062h32.976v20.242H172.912z M167.401,5.515v27.278h-27.289V5.515H167.401z M167.401,85.907v27.278h-27.289V85.907H167.401z M167.401,169.405v27.289h-27.289v-27.289H167.401z M34.808,119.884v-40.67h40.67v40.67H34.808z' />
  </SvgIcon>
);

export default DistrictChildRelationIcon;
